module.exports = __webpack_public_path__ + "img/js.fac6412.png";